import { Component, OnInit } from '@angular/core';
import { UserDataApi } from '../../../../assets/js/lb-sdk';
import { LoadingAndErrors } from '../../../classes';
import { finalize } from 'rxjs/operators';

interface ForgotPasswordForm {
  email: string
};

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent extends LoadingAndErrors implements OnInit {
  forgotPassword: ForgotPasswordForm = {
    email: undefined
  };
  success: boolean;

  constructor(
    private userDataApi: UserDataApi
  ) {
    super();
  }

  ngOnInit() {
  }

  submit(form) {
    if (form.valid) {
      this.loading.form = true;
      this.clearErrors();
      this.userDataApi
        .resetPassword(this.forgotPassword)
        .pipe(finalize(() => {
          this.loading.form = false;
        }))
        .subscribe(
          () => {
            this.success = true;
          },
          error => {
            var errorMessage = error.message;
            if (errorMessage === 'Email not found') {
              errorMessage = "Password link sent";
            }
            this.errors.forgot = errorMessage;
          }
        );
    }
  }

}
